import { Idle } from "pages/flyer/builder/drawer/state/newShapes/CustomTextUtil/toolStates/Idle";
import { Pointing } from "pages/flyer/builder/drawer/state/newShapes/CustomTextUtil/toolStates/Pointing";
import { BaseBoxShapeTool } from "@tldraw/tldraw";

export class CustomCloudTool extends BaseBoxShapeTool {
  static id = "customCloud";
  static initial = "idle";
  shapeType = "customCloud";
}
export class CustomHeartTool extends BaseBoxShapeTool {
  static id = "customHeart";
  static initial = "idle";
  shapeType = "customHeart";
}
export class CustomEllipseTool extends BaseBoxShapeTool {
  static id = "customEllipse";
  static initial = "idle";
  shapeType = "customEllipse";
}
export class CustomOvalTool extends BaseBoxShapeTool {
  static id = "customOval";
  static initial = "idle";
  shapeType = "customOval";
}
export class CustomRectangleTool extends BaseBoxShapeTool {
  static id = "customRect";
  static initial = "idle";
  // static children(): TLStateNodeConstructor[] {
  //   return [RectIdle, RectPointing];
  // }
  shapeType = "customRect";
}
export class CustomTriangleTool extends BaseBoxShapeTool {
  static id = "customTriangle";
  static initial = "idle";
  shapeType = "customTriangle";
}

export class CustomStarTool extends BaseBoxShapeTool {
  static id = "customStar";
  static initial = "idle";
  shapeType = "customStar";
}
export class CustomCheckboxTool extends BaseBoxShapeTool {
  static id = "customCheckBox";
  static initial = "idle";
  shapeType = "customCheckBox";
}
export class CustomXBoxTool extends BaseBoxShapeTool {
  static id = "customXBox";
  static initial = "idle";
  shapeType = "customXBox";
}
export class CustomTextTool extends BaseBoxShapeTool {
  static id = "customText";
  static initial = "idle";
  static children(): any {
    return [Idle, Pointing];
  }
  shapeType = "customText";
}

export class CustomSvgTool extends BaseBoxShapeTool {
  static id = "customSvg";
  static initial = "idle";
  shapeType = "customSvg";
}

// export class CustomScale extends BaseBoxShapeTool {
//   static id = "scale";
//   static initial = "idle";
//   shapeType = "scale";
// }

// export class CustomDiamondTool extends BaseBoxShapeTool {
//   static id = "customDiamond";
//   static initial = "idle";
//   shapeType = "customDiamond";
// }
// export class CustomHexagonTool extends BaseBoxShapeTool {
//   static id = "customHexagon";
//   static initial = "idle";
//   shapeType = "customHexagon";
// }
// export class CustomPentagonTool extends BaseBoxShapeTool {
//   static id = "customPentagon";
//   static initial = "idle";
//   shapeType = "customPentagon";
// }
// export class CustomOctagonTool extends BaseBoxShapeTool {
//   static id = "customOctagon";
//   static initial = "idle";
//   shapeType = "customOctagon";
// }
// export class CustomTrapezoidTool extends BaseBoxShapeTool {
//   static id = "customTrapezoid";
//   static initial = "idle";
//   shapeType = "customTrapezoid";
// }

// export class CustomRhombusTool extends BaseBoxShapeTool {
//   static id = "customRhombus";
//   static initial = "idle";
//   shapeType = "customRhombus";
// }
// export class CustomRhombus2Tool extends BaseBoxShapeTool {
//   static id = "customRhombus2";
//   static initial = "idle";
//   shapeType = "customRhombus2";
// }
// export class CustomArrowUpTool extends BaseBoxShapeTool {
//   static id = "customArrowUp";
//   static initial = "idle";
//   shapeType = "customArrowUp";
// }
// export class CustomArrowDownTool extends BaseBoxShapeTool {
//   static id = "customArrowDown";
//   static initial = "idle";
//   shapeType = "customArrowDown";
// }
// export class CustomArrowLeftTool extends BaseBoxShapeTool {
//   static id = "customArrowLeft";
//   static initial = "idle";
//   shapeType = "customArrowLeft";
// }
// export class CustomArrowRightTool extends BaseBoxShapeTool {
//   static id = "customArrowRight";
//   static initial = "idle";
//   shapeType = "customArrowRight";
// }
